import {ValueObject} from '@s-ui/domain'

import {ModelVehiclesValueObject} from './ModelVehiclesValueObject.js'

export class ListModelVehiclesValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static createFromApi({items = []}) {
    const models = items.map(model => ModelVehiclesValueObject.createFromApi(model))
    return new ListModelVehiclesValueObject({value: models})
  }

  getModelCards() {
    if (!this.#value?.length) return []
    return this.#value.map(model => model.getModelCard())
  }

  getModelCardsForModelDetail() {
    if (!this.#value?.length) return []
    return this.#value.map(model => model.getModelCardsForModelDetail())
  }

  getFirstModel() {
    if (!this.#value?.length) return null
    return this.#value[0].getModelCardsForModelDetail()
  }

  get value() {
    return {
      items: this.#value.map(model => model.value)
    }
  }
}
